import getters from './product-list/getters'
import mutations from './product-list/mutations'
import actions from './product-list/actions'
import { SESSION_STORAGE } from './product-list/shared'

const state = {
  products: JSON.parse(sessionStorage && sessionStorage.getItem(SESSION_STORAGE.productList)) || []
}

export default {
  state,
  getters,
  mutations,
  actions
}
